export const errorKey = 'WECOM_ERR';
export const setError = message => {
  localStorage.setItem(errorKey, message);
};
export const cleanError = () => {
  localStorage.removeItem(errorKey);
};
export const getError = type => {
  let ret = TYPES[type];
  return ret || localStorage.getItem(errorKey) || '出错了！';
};
export const TYPES = {
  'user-1': '认证异常！',
  'user-2': 'eid异常！',
  'eid-1': '认证异常！',
  'eid-2': 'eid异常！',
  user_bind_para: 'user_bind_para参数丢失！',
  eid_request: 'eid请求异常！',
  oauth_request: '认证请求异常！',
  employee: '员工账户！'
};
export default {
  TYPES,
  getError,
  cleanError,
  setError,
  errorKey
};
